import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_assigned_client_users = _resolveComponent("assigned-client-users")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_unassigned_client_users = _resolveComponent("unassigned-client-users")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.clientName,
    size: "sm",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        dense: "",
        class: "text-grey-8",
        "active-color": "primary",
        "indicator-color": "primary",
        align: "justify",
        "narrow-indicator": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            name: "assigned",
            label: "Assigned"
          }),
          _createVNode(_component_q_tab, {
            name: "unassigned",
            label: "Unassigned"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, { name: "assigned" }, {
            default: _withCtx(() => [
              _createVNode(_component_assigned_client_users, { client: _ctx.client }, null, 8, ["client"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, { name: "unassigned" }, {
            default: _withCtx(() => [
              _createVNode(_component_unassigned_client_users, { client: _ctx.client }, null, 8, ["client"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["title"]))
}